import React from "react";
import styled from "styled-components";
import CryptidCard from "./cryptidCard";
import PlusIcon from "../../assets/icons/plus-stroke.png";
import DeckMaskot from "../../assets/images/deckCardMaskot.svg";
import LockedImage  from "../../assets/images/lockedImage.png";


const DeckCard = ({ card ,isLocked,containerStyle,clickAction}) => { 
    return (
        <Container style={containerStyle || null} onClick={isLocked ? null : clickAction ?  ()=>clickAction() :  null}>
            <Maskot src={DeckMaskot} alt="Maskot" />
            {isLocked ?
                 <Lock src={LockedImage} alt="Lock" />
                :
                <IconContainer>
                <img src={PlusIcon} alt="Add" />
            </IconContainer>
            }
            {card?.name && <CryptidCard inDeck="true" cryptid={card} />}
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    aspect-ratio: 859/1320;
    cursor: pointer;
    background: linear-gradient(360deg, #876BC6 0%, #7859C1 55.98%, #6E4EBB 111.96%);
    border: 1.79px solid #FFFFFF;
    border-radius: 7.58%;
    display: flex;
    justify-content: center;
    box-shadow: 0px 4px 0px 0px #6747AC;
`
const IconContainer = styled.div`
    position: absolute;
    width:100%;
    aspect-ratio: 1/1;
    height:auto;
    max-width: 50%;
    border-radius: 50%;
    background-color: #6747AC;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
    bottom: 40%;
    transform: translateY(40%);
    img{
        width: 50%;
        aspect-ratio: 1/1;
    }
`
const Maskot = styled.img`
    position: absolute;
    top:15%;
    width: 48%;
    height: auto;

`
const Lock = styled.img`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
`

export default DeckCard;